export default "__VITE_ASSET__CjxWJY71__"